import React, { useCallback, useEffect, useState } from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps";
import { marker } from "../../cluterlatlan"
import { state } from "../../Statelatlng"

const MapWithPlaces = withScriptjs(withGoogleMap(props =>{
  const [markers, setMarker] = useState(state)
  const { location, setlocation } = props;
  const [activeMarker, setActiveMarker] = useState(false);
  const [incureentL, setincureentL] = useState(false);
  const [zoom, setzoom] = useState(5);
  let center = { lat: location?.lat, lng: location?.lng };
  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  const currentlocation = useCallback(() => {
    return (
      <Marker
        key={location?.pincodeId}
        position={{ lat: location?.lat, lng: location?.lng }}
        onClick={() => setincureentL(!incureentL)}
      >
        {incureentL ? (
          <InfoWindow onCloseClick={() => setincureentL(null)}>
            <p>{location?.address}</p>
          </InfoWindow>
        ) : null}
      </Marker>
    )
  } , [location , incureentL])

  useEffect(() => {
    if (location?.lat !== 22.878597243716452) {
      setMarker(marker);
      currentlocation();
      setzoom(13);
    }
  }, [location, currentlocation]);

  const handleOnLoad = (map) => {
    const bounds = new window.google.maps.LatLngBounds();
    markers.forEach(({ lat, lng }) => bounds.extend({ lat, lng }));
    map.fitBounds(bounds);
    map.center = center;
  };

  const getLotionOnclick = (e) => {
    let lat = e?.latLng?.lat();
    let lng = e?.latLng?.lng();
    var geocoder = new window.google.maps.Geocoder();
    geocoder.geocode(
      {
        latLng: e.latLng,
      },
      function (results, status) {
        if (status === window.google.maps.GeocoderStatus.OK) {
          if (results) {
            let add = results[0]?.address_components;
            let pin = add[add.length - 1]?.long_name;
            let location_data = results[0]?.formatted_address;
            setlocation({
              lat: lat,
              lng: lng,
              pincode: pin,
              address: location_data,
            });
          }
          setActiveMarker(true);
        }
      }
    );
  };

  return (
    <>
      <GoogleMap
        id="map"
        onLoad={handleOnLoad}
        center={center}
        zoom={zoom}
        onClick={getLotionOnclick}
      >
        {location.lat !== 22.878597243716452 && currentlocation()}
        {markers.map(({ id, name, lat, lng, img }) => (
          <Marker
            key={id}
            position={{ lat: lat, lng: lng }}
            onClick={() => handleActiveMarker(id)}
            icon={{
              url: img,
              scaledSize: new window.google.maps.Size(23, 32),
            }}
          >
            {activeMarker === id ? (
              <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                <p>{name}</p>
              </InfoWindow>
            ) : null}
          </Marker>
        ))}
      </GoogleMap>
    </>
  );}
))

export default MapWithPlaces;
